import { Transforms } from 'slate';

export function onChange(autocompleteRef, editor) {
  // Removing an existing suggestion will cause onChange to fire.. but we don't want to immediately
  // re-add the suggestion, otherwise it'll never go away. So we set this flag when removing, and
  // unset it after the onChange fires for the removal.
  if (autocompleteRef.current.isRemoving) {
    autocompleteRef.current.isRemoving = false;
    return;
  }

  editor.ensureAutocompleteExists();
}

export function onKeyDown(context, editor, evt) {
  const existingAutocompletes = editor.getAutocompleteNodes();
  if (existingAutocompletes.length === 0) {
    return;
  }

  // If a user types part of the autocomplete, insert that character then continue to show
  // the rest of the autocomplete.
  const [autocompleteNode, autocompletePath] = existingAutocompletes[0];
  if (isKeyFirstCharacterInAutocomplete(evt, autocompleteNode)) {
    const autocompleteText = autocompleteNode['data-text'];
    Transforms.insertText(editor, autocompleteText[0]);

    const nextText = autocompleteText.slice(1);
    const fragment = editor.getSaturatedFragment(`<div>${nextText}</div>`);

    // Update the autocomplete node with the new text / fragment
    Transforms.setNodes(
      editor,
      {
        'data-fragment': fragment,
        'data-text': nextText,
        isPartial: true,
      },
      {
        at: autocompletePath,
      }
    );
    evt.preventDefault();
    return true;
  }

  // Otherwise, when the user types, we don't need to show the autocomplete suggestion anymore.
  editor.removeAutocomplete();

  // But if we were showing a suggestion and they hit Tab or Right Arrow, we'll insert it.
  const shouldInsertAutocomplete = evt.key === 'Tab' || evt.key === 'ArrowRight';
  if (shouldInsertAutocomplete) {
    evt.preventDefault();

    const id = autocompleteNode['data-id'];
    const text = autocompleteNode['data-text'];
    const fragment = autocompleteNode['data-fragment'];

    if (fragment) {
      Transforms.insertFragment(editor, fragment);
    } else {
      Transforms.insertText(editor, text);
    }

    editor.updateVariables();
    context.onUpdateGreetingSuggestionScore(id);
  }
}

function isKeyFirstCharacterInAutocomplete(evt, autocompleteNode) {
  // Allow agents to type the first character even if the capitalization is different
  const key = evt.key.toLowerCase();
  const text = autocompleteNode['data-text'];

  return key === (text[0] || '').toLowerCase();
}
